module.exports = __webpack_public_path__ + "static/media/user-white.75fba446.svg";